const hasOwnProperty = (obj, prop) => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
const hasMethod = (value, methodName) => {
    return hasOwnProperty(value, methodName) && typeof value[methodName] === 'function';
};
export const isErrorTrackingIntegration = (value) => {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    return (hasMethod(value, 'addError') &&
        hasMethod(value, 'init') &&
        hasMethod(value, 'setContext') &&
        hasMethod(value, 'setUser') &&
        hasMethod(value, 'clearUser'));
};
const isErrorEmitter = (value) => {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    return hasMethod(value, 'start') && hasMethod(value, 'stop');
};
const isEventRecorder = (value) => {
    return isErrorTrackingIntegration(value) && hasMethod(value, 'replay');
};
const isErrorEmitterPlugin = (value) => {
    return typeof value === 'function';
};
export const startErrorEmitters = (emitters) => {
    emitters.forEach((emitter) => {
        emitter.start();
    });
};
export const initIntegrations = (integrations) => {
    integrations.forEach((integration) => {
        integration.init();
    });
};
export const setErrorStackTrace = (stackTraceLimit) => {
    if (typeof stackTraceLimit === 'number') {
        Error.stackTraceLimit = stackTraceLimit;
    }
};
export const validateEmittersPlugins = (plugins) => {
    plugins.forEach((plugin) => {
        if (!isErrorEmitterPlugin(plugin)) {
            throw new Error('Invalid error emitter plugin');
        }
    });
};
export const validateEmitters = (emitters) => {
    emitters.forEach((emitter) => {
        if (!isErrorEmitter(emitter)) {
            throw new Error('Invalid error emitter');
        }
    });
};
export const validateIntegrations = (integrations) => {
    integrations.forEach((integration) => {
        if (!isErrorTrackingIntegration(integration)) {
            throw new Error('Invalid error tracking integration');
        }
    });
};
export const validateEventRecorder = (recorder) => {
    if (recorder && !isEventRecorder(recorder)) {
        throw new Error('Invalid event recorder');
    }
};
export const validateStackTraceLimit = (value) => {
    if (typeof value !== 'undefined' && typeof value !== 'number') {
        throw new Error('Invalid stackTraceLimit');
    }
};
export const noop = () => undefined;
//# sourceMappingURL=utils.js.map